import { TextField, Typography } from '@mui/material';
import { StyledContainer, StyledForm, StyledFormRow } from './LocationAndContact.styles';
import { FORM_STRUCTURE } from './LocationAndContact.constants';
import { parseAddress } from '../../../utils/helpers/venues/venuesHelpers';

const LocationAndContact = ({ name, address }) => {
  const { streetAddress, city, state, zipcode } = parseAddress(address);

  const values = {
    name,
    streetAddress,
    city,
    state,
    zipcode,
  };

  const commonTextFieldProps = {
    fullWidth: true,
    variant: 'filled',
    disabled: true,
    InputProps: {
      readOnly: true,
      disableUnderline: true,
    },
    InputLabelProps: { shrink: true },
  };

  return (
    <StyledContainer>
      <>
        <Typography variant="h6">Location & Contact</Typography>
        <Typography variant="subtitle2">
          <em>All fields are populated from your POS system.</em>
        </Typography>
      </>

      <StyledForm>
        {FORM_STRUCTURE.map((section, sectionIndex) => (
          <StyledFormRow key={sectionIndex}>
            {section.fields.map((field, fieldIndex) => (
              <TextField
                key={`${sectionIndex}-${fieldIndex}`}
                label={field.label}
                value={values[field.key] || field.defaultValue || ''}
                {...commonTextFieldProps}
              />
            ))}
          </StyledFormRow>
        ))}
      </StyledForm>
    </StyledContainer>
  );
};

export default LocationAndContact;
